enum Visibility {
  None = 0,
  VisibleToAll = 1,
  MembersOnly = 2,
}

export default Visibility;
